// Module
var code = "<div class=\"radio-group\"> <div ng-repeat=\"(key, option) in to.options\" class=\"radio\"> <label> <input type=\"radio\" id=\"{{id + '_'+ $index}}\" tabindex=\"0\" ng-value=\"option[to.valueProp || 'value']\" ng-model=\"model[options.key]\"> {{option[to.labelProp || 'name']}} </label> </div> </div> ";
// Exports
var _module_exports = code;;
var path = 'ui-formly/types/radio/index.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;